import { useState, useEffect } from "react";
import { deref } from "kanopi-components/utils/primitives";

import { ClaimStateFilterEnum } from "kw/api/zeus";

import { substituteProfileData } from "kw/util/substituteRiskData";
import { useAPI } from "kw/api/useAPI";

type TUseClaimState = {
  claimProfileId: bigint;
  filterBy?: ClaimStateFilterEnum;
};

export const useClaimState = (args: TUseClaimState) => {
  const { claimProfileId, filterBy } = args || {};
  const { loading, query } = useAPI();
  const [claimState, setClaimState] = useState();

  useEffect(() => {
    const getData = async () => {
      query(getClaimStateQuery(claimProfileId, filterBy), (response) => {
        const results = [];
        let finalClaimProfile;
        for (const questionSet of deref(response, "claimState.questionSets", [])) {
          const [enquiry, claimProfile] = substituteProfileData(
            {
              questionSet,
            },
            deref(response, "claimState.claimProfile", {})
          );
          results.push(enquiry.questionSet);
          finalClaimProfile = claimProfile;
        }
        setClaimState({ questionSets: results, claimProfile: finalClaimProfile });
      });
    };

    if (claimProfileId) getData();
  }, [claimProfileId]);

  return { claimState, loading };
};

const getClaimStateQuery = (
  claimProfileId: bigint,
  filterBy?: ClaimStateFilterEnum
) => {
  return {
    claimState: [
      {
        claimProfileId,
        filterBy: filterBy,
      },
      {
        claimProfile: {
          id: true,
          data: true,
        },
        questionSets: {
          id: true,
          title: true,
          description: true,
          key: true,
          questions: {
            id: true,
            help: true,
            label: true,
            inputType: true,
            inputArgs: true,
            storagePath: true,
            order: true,
            validators: true,
            default: true,
          },
          order: true,
        },
      },
    ],
  };
};
